import { render, staticRenderFns } from "./EditDynamicCategory.vue?vue&type=template&id=0f6e3c0b&scoped=true&"
import script from "./EditDynamicCategory.vue?vue&type=script&lang=js&"
export * from "./EditDynamicCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditDynamicCategory.vue?vue&type=style&index=0&id=0f6e3c0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e3c0b",
  null
  
)

export default component.exports